import { modalActions } from '../../modals/modal.store'
import { useCellDerivedState, useCellState } from '../CellContext'
import { getContentForTextCell } from './content.helpers'

import { HistoryIcon } from 'lucide-react'

import { CellUpload } from '../upload/CellUpload'
import { ContentPreviewRenderer } from './ContentPreviewRenderer'

import { CellToolbar, CellToolbarItem } from '../toolbar/CellToolbar'
import { CellToolbarItemEdit } from '../toolbar/CellToolbar.items'

/**
 * Render static preview of cell content.
 *
 * @note This is only for rich-text cells, as determined in the `<Cell>` component.
 */
export function CellContentPreview() {
  const { cell } = useCellState()

  const cellContentAsHTML = getContentForTextCell(cell?.content)

  return (
    <>
      <CellUpload>
        <ContentPreviewRenderer contentAsHTML={cellContentAsHTML} />
      </CellUpload>
      <CellToolbar>
        <CellToolbarItemEdit />

        <CellToolbarItemHistory />
      </CellToolbar>
    </>
  )
}

/**
 * History item is only available for Richtext Cells
 * and only shown in Previw mode.
 */
function CellToolbarItemHistory() {
  const { cell } = useCellState()
  const { isReadOnly } = useCellDerivedState()

  const cellId = cell?.id

  // Disable for non-existing cells
  const isDisabled = !cellId || isReadOnly

  return (
    <CellToolbarItem
      tooltip="Show history"
      aria-label="Show history"
      disabled={isDisabled}
      onClick={() => {
        if (isDisabled) return

        modalActions.open('CELL_HISTORY', {
          cellId: cellId,
        })
      }}
    >
      <HistoryIcon />
    </CellToolbarItem>
  )
}
